import jwt from "jsonwebtoken";

import ParticipantLoginedService from "../services/ParticipantLoginedService";

function checkTokenValid (token) {
  if (token) {
    const decodedToken = jwt.decode(token);
    return decodedToken && decodedToken.exp * 1000 > new Date().getTime();
  }
}

export default {
  namespaced: true,
  state: {
    participantToken: localStorage.getItem("participantToken") || "",
    participant: localStorage.getItem("participant") || "",
    participantHost: localStorage.getItem("participantHost") || "",
    participantName: localStorage.getItem("participantName") || "",
    isHandup: false
  },
  mutations: {
    authSuccess (state, { participantToken, participant, participantHost, firstName }) {
      state.status = "success";
      state.participantToken = participantToken;
      state.participant = participant;
      state.participantHost = participantHost;
      state.participantName = firstName
    },
    authError (state) {
      state.status = "error";
    },
    logOut (state) {
      state.participantToken = "";
      state.participant = "";
      state.participantHost = ""
      state.participantName = ""
    },
    updateHandup (state, status) {
      state.isHandup = status;
    }
  },
  actions: {
    logInParticipant ({ commit }, participant) {
      return ParticipantLoginedService.participantLogIn(participant)
        .then(res => {
          const status = res.data.status || false;
          if (status) {
            const token = res.data.token || "";
            const decode = jwt.decode(token);
            localStorage.setItem("participantToken", token);
            localStorage.setItem("participant", decode.participant);
            localStorage.setItem("participantHost", decode.host);
            localStorage.setItem("participantName", decode.firstName)
            commit("authSuccess", {
              participantToken: token,
              participant: decode.participant,
              participantHost: decode.host,
              firstName: decode.firstName
            });
          }
          return res;
        })
        .catch(() => {
          commit("authError");
          localStorage.removeItem("participantToken");
        });
    },
    logOutParticipant ({ commit }) {
      return new Promise(resolve => {
        commit("logOut");
        localStorage.clear();
        resolve();
      });
    },
    updateHandup ({ commit }, status) {
      commit('updateHandup', status)
    },
    updatePassword({state}, data) {
      return ParticipantLoginedService.updatePassword(data, state.participantToken).then(result => {
        return result
      })
    }
  },
  getters: {
    isLoggedIn: state => checkTokenValid(state.participantToken)
    // isLoggedIn: state => !!state.token && checkTokenValid(state.token),
  }
};
